"use strict";
exports.__esModule = true;
exports.DebridgeSwapProvider = void 0;
var tslib_1 = require("tslib");
var ethers_1 = require("ethers");
var chain_provider_1 = require("../../factory/chain-provider");
var transaction_service_1 = require("../../transaction/transaction.service");
var config_1 = require("./config");
var utils_1 = require("../../common/utils");
var SignatureVerifier_json_1 = tslib_1.__importDefault(require("./abi/SignatureVerifier.json"));
var constants_1 = require("@ethersproject/constants");
var typechain_types_1 = require("../../../typechain-types");
var utils_2 = require("ethers/lib/utils");
var bignumber_js_1 = tslib_1.__importDefault(require("bignumber.js"));
var transaction_status_1 = require("../../transaction/constants/transaction-status");
var gelato_1 = require("../../gasless-providers/gelato");
var DebridgeSwapProvider = /** @class */ (function () {
    function DebridgeSwapProvider() {
    }
    DebridgeSwapProvider.swap = function (swapRequest, pkOrProvider, isGasless) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var chainId, isSrcChainSupported, isDstChainSupported, isSwapFromNative, wallet, fromAmountInUnits, contract, _a, _b, _c, decimals;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, (0, utils_1.getChainID)(pkOrProvider)];
                    case 1:
                        chainId = _d.sent();
                        if (chainId !== swapRequest.srcChainId)
                            throw Error("External provider is connected to a different source chain");
                        isSrcChainSupported = !!this.config.chains[swapRequest.srcChainId];
                        isDstChainSupported = !!this.config.chains[swapRequest.srcChainId];
                        if (new bignumber_js_1["default"](swapRequest.srcChainTokenInAmount).lte(0) ||
                            !isSrcChainSupported ||
                            !isDstChainSupported)
                            throw Error("Swap not supported");
                        isSwapFromNative = swapRequest.srcChainTokenIn !== constants_1.AddressZero;
                        if (isGasless && isSwapFromNative)
                            throw Error("Gasless not supported when swapping from native");
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, swapRequest.srcChainId)];
                    case 2:
                        wallet = _d.sent();
                        if (!isSwapFromNative) return [3 /*break*/, 6];
                        _b = (_a = typechain_types_1.ERC20__factory).connect;
                        _c = [constants_1.AddressZero];
                        return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(swapRequest.srcChainId)];
                    case 3:
                        contract = _b.apply(_a, _c.concat([_d.sent()])).attach(swapRequest.srcChainTokenIn);
                        return [4 /*yield*/, contract.decimals()];
                    case 4:
                        decimals = _d.sent();
                        fromAmountInUnits = (0, utils_2.parseUnits)(swapRequest.srcChainTokenInAmount, decimals).toString();
                        return [4 /*yield*/, this.approveToken(contract, fromAmountInUnits, wallet)];
                    case 5:
                        _d.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        fromAmountInUnits = (0, utils_2.parseEther)(swapRequest.srcChainTokenInAmount).toString();
                        _d.label = 7;
                    case 7:
                        if (swapRequest.srcChainId === swapRequest.dstChainId)
                            return [2 /*return*/, this.singleChainSwap(swapRequest, fromAmountInUnits, wallet, isGasless, pkOrProvider)];
                        return [2 /*return*/, this.crossChainSwap(swapRequest, fromAmountInUnits, wallet, isGasless, pkOrProvider)];
                }
            });
        });
    };
    DebridgeSwapProvider.getQuote = function (quoteRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isSrcChainSupported, isDstChainSupported, fromAmountInUnits, dstTokenDecimals, contract, _a, _b, _c, decimals, contract, _d, _e, _f;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        isSrcChainSupported = !!this.config.chains[quoteRequest.srcChainId];
                        isDstChainSupported = !!this.config.chains[quoteRequest.srcChainId];
                        if (new bignumber_js_1["default"](quoteRequest.srcChainTokenInAmount).lte(0) ||
                            !isSrcChainSupported ||
                            !isDstChainSupported)
                            throw Error("Swap not supported");
                        if (!(quoteRequest.srcChainTokenIn !== constants_1.AddressZero)) return [3 /*break*/, 3];
                        _b = (_a = typechain_types_1.ERC20__factory).connect;
                        _c = [constants_1.AddressZero];
                        return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(quoteRequest.srcChainId)];
                    case 1:
                        contract = _b.apply(_a, _c.concat([_g.sent()])).attach(quoteRequest.srcChainTokenIn);
                        return [4 /*yield*/, contract.decimals()];
                    case 2:
                        decimals = _g.sent();
                        fromAmountInUnits = (0, utils_2.parseUnits)(quoteRequest.srcChainTokenInAmount, decimals).toString();
                        return [3 /*break*/, 4];
                    case 3:
                        fromAmountInUnits = (0, utils_2.parseEther)(quoteRequest.srcChainTokenInAmount).toString();
                        _g.label = 4;
                    case 4:
                        if (!(quoteRequest.dstChainTokenOut !== constants_1.AddressZero)) return [3 /*break*/, 7];
                        _e = (_d = typechain_types_1.ERC20__factory).connect;
                        _f = [constants_1.AddressZero];
                        return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(quoteRequest.dstChainId)];
                    case 5:
                        contract = _e.apply(_d, _f.concat([_g.sent()])).attach(quoteRequest.dstChainTokenOut);
                        return [4 /*yield*/, contract.decimals()];
                    case 6:
                        dstTokenDecimals = _g.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        dstTokenDecimals = 18;
                        _g.label = 8;
                    case 8:
                        if (quoteRequest.srcChainId === quoteRequest.dstChainId)
                            return [2 /*return*/, this.singleChainSwapQuote(quoteRequest, fromAmountInUnits, dstTokenDecimals)];
                        return [2 /*return*/, this.crossChainSwapQuote(quoteRequest, fromAmountInUnits, dstTokenDecimals)];
                }
            });
        });
    };
    DebridgeSwapProvider.singleChainSwapQuote = function (quoteRequest, fromAmountInUnits, decimals) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var chainId, tokenIn, tokenOut, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        chainId = quoteRequest.srcChainId, tokenIn = quoteRequest.srcChainTokenIn, tokenOut = quoteRequest.dstChainTokenOut;
                        return [4 /*yield*/, (0, utils_1.fetchGet)(this.config.url + "chain/estimation", {
                                chainId: chainId,
                                tokenIn: tokenIn,
                                tokenInAmount: fromAmountInUnits,
                                tokenOut: tokenOut
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.estimation)
                            throw Error('Could not get quote');
                        return [2 /*return*/, {
                                amount: (0, utils_2.formatUnits)(response.estimation.tokenOut.amount, decimals),
                                minAmount: (0, utils_2.formatUnits)(response.estimation.tokenOut.minAmount, decimals)
                            }];
                }
            });
        });
    };
    DebridgeSwapProvider.singleChainSwap = function (swapRequest, fromAmountInUnits, wallet, isGasless, pkOrProvider) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var chainId, tokenIn, tokenInAmount, tokenOut, tokenOutRecipient, response, tx, from, preparedTx, swapTx;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        chainId = swapRequest.srcChainId, tokenIn = swapRequest.srcChainTokenIn, tokenInAmount = swapRequest.srcChainTokenInAmount, tokenOut = swapRequest.dstChainTokenOut, tokenOutRecipient = swapRequest.dstChainTokenOutRecipient;
                        return [4 /*yield*/, (0, utils_1.fetchGet)(this.config.url + "chain/transaction", {
                                chainId: chainId,
                                tokenIn: tokenIn,
                                tokenInAmount: fromAmountInUnits,
                                tokenOut: tokenOut,
                                tokenOutRecipient: tokenOutRecipient
                            })];
                    case 1:
                        response = _a.sent();
                        tx = response.tx;
                        if (!tx)
                            throw Error("Swap Tx Could not be created...Try again perhaps with different params");
                        return [4 /*yield*/, wallet.getAddress()];
                    case 2:
                        from = _a.sent();
                        if (isGasless)
                            return [2 /*return*/, gelato_1.Gelato.sendTx(chainId, tx.to, from, tx.data, pkOrProvider)];
                        return [4 /*yield*/, transaction_service_1.TransactionService.prepareTransaction(tslib_1.__assign(tslib_1.__assign({ from: from }, tx), { value: ethers_1.BigNumber.from(tx.value) }), chainId)];
                    case 3:
                        preparedTx = _a.sent();
                        return [4 /*yield*/, wallet.sendTransaction(preparedTx)];
                    case 4:
                        swapTx = _a.sent();
                        return [2 /*return*/, swapTx.hash];
                }
            });
        });
    };
    DebridgeSwapProvider.crossChainSwapQuote = function (quoteRequest, fromAmountInUnits, decimals) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var srcChainId, srcChainTokenIn, dstChainId, dstChainTokenOut, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        srcChainId = quoteRequest.srcChainId, srcChainTokenIn = quoteRequest.srcChainTokenIn, dstChainId = quoteRequest.dstChainId, dstChainTokenOut = quoteRequest.dstChainTokenOut;
                        return [4 /*yield*/, (0, utils_1.fetchGet)(this.config.url + "estimation", {
                                srcChainId: srcChainId,
                                srcChainTokenIn: srcChainTokenIn,
                                srcChainTokenInAmount: fromAmountInUnits,
                                dstChainId: dstChainId,
                                dstChainTokenOut: dstChainTokenOut
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.estimation)
                            throw Error('Could not get quote');
                        return [2 /*return*/, {
                                amount: (0, utils_2.formatUnits)(response.estimation.dstChainTokenOut.amount, decimals),
                                minAmount: (0, utils_2.formatUnits)(response.estimation.dstChainTokenOut.minAmount, decimals)
                            }];
                }
            });
        });
    };
    DebridgeSwapProvider.crossChainSwap = function (swapRequest, fromAmountInUnits, wallet, isGasless, pkOrProvider) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var srcChainId, srcChainTokenIn, dstChainId, dstChainTokenOut, dstChainTokenOutRecipient, response, tx, from, preparedTx, sendTx;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        srcChainId = swapRequest.srcChainId, srcChainTokenIn = swapRequest.srcChainTokenIn, dstChainId = swapRequest.dstChainId, dstChainTokenOut = swapRequest.dstChainTokenOut, dstChainTokenOutRecipient = swapRequest.dstChainTokenOutRecipient;
                        return [4 /*yield*/, (0, utils_1.fetchGet)(this.config.url + "transaction", {
                                srcChainId: srcChainId,
                                srcChainTokenIn: srcChainTokenIn,
                                srcChainTokenInAmount: fromAmountInUnits,
                                dstChainId: dstChainId,
                                dstChainTokenOut: dstChainTokenOut,
                                dstChainTokenOutRecipient: dstChainTokenOutRecipient
                            })];
                    case 1:
                        response = _a.sent();
                        tx = response.tx;
                        if (!tx)
                            throw Error("Swap Tx Could not be created...Try again perhaps with different params");
                        return [4 /*yield*/, wallet.getAddress()];
                    case 2:
                        from = _a.sent();
                        if (isGasless)
                            return [2 /*return*/, gelato_1.Gelato.sendTx(srcChainId, tx.to, from, tx.data, pkOrProvider)];
                        return [4 /*yield*/, transaction_service_1.TransactionService.prepareTransaction(tslib_1.__assign(tslib_1.__assign({ from: from }, tx), { value: ethers_1.BigNumber.from(tx.value) }), srcChainId)];
                    case 3:
                        preparedTx = _a.sent();
                        return [4 /*yield*/, wallet.sendTransaction(preparedTx)];
                    case 4:
                        sendTx = _a.sent();
                        return [2 /*return*/, sendTx.hash];
                }
            });
        });
    };
    DebridgeSwapProvider.approveToken = function (contract, amount, wallet) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, tx, preparedTx, _c, _d, _e, approveTx;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _a = this.hasAllowance;
                        _b = [contract, amount];
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([_f.sent()]))];
                    case 2:
                        if (_f.sent())
                            return [2 /*return*/, true];
                        return [4 /*yield*/, contract.populateTransaction.approve(this.config.routerAddress, amount)];
                    case 3:
                        tx = _f.sent();
                        _d = (_c = transaction_service_1.TransactionService).prepareTransaction;
                        _e = [tslib_1.__assign(tslib_1.__assign({}, tx), { to: contract.address })];
                        return [4 /*yield*/, wallet.getChainId()];
                    case 4: return [4 /*yield*/, _d.apply(_c, _e.concat([_f.sent()]))];
                    case 5:
                        preparedTx = _f.sent();
                        return [4 /*yield*/, wallet.sendTransaction(preparedTx)];
                    case 6:
                        approveTx = _f.sent();
                        return [4 /*yield*/, this.waitForApproveConfirmations(approveTx.hash, wallet.provider)];
                    case 7:
                        _f.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    DebridgeSwapProvider.hasAllowance = function (contract, amount, fromAddress) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allowance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, contract.allowance(fromAddress, this.config.routerAddress)];
                    case 1:
                        allowance = _a.sent();
                        return [2 /*return*/, allowance.gte(amount)];
                }
            });
        });
    };
    DebridgeSwapProvider.waitForApproveConfirmations = function (approveTxHash, chainProvider) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, (0, utils_1.withInterval)(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var tx, e_1;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, chainProvider.getTransaction(approveTxHash)];
                                case 1:
                                    tx = _a.sent();
                                    if (tx && tx.confirmations && tx.confirmations > 0) {
                                        return [2 /*return*/, {
                                                status: "SUCCESS"
                                            }];
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_1 = _a.sent();
                                    throw Error("Problem Confirming approval Tx, ".concat(e_1));
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    DebridgeSwapProvider.getSwapStatus = function (statusRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (statusRequest.srcChainId === statusRequest.dstChainId)
                    return [2 /*return*/, this.getSingleChainSwapStatus(statusRequest.txHash, statusRequest.srcChainId)];
                return [2 /*return*/, this.getCrossChainSwapStatus(statusRequest.txHash, statusRequest.srcChainId, statusRequest.dstChainId)];
            });
        });
    };
    DebridgeSwapProvider.getSingleChainSwapStatus = function (swapTxHash, chainId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, transaction_service_1.TransactionService.getTransactionStatus(swapTxHash, chainId, this.config.chains[chainId].minBlockConfirmation)];
            });
        });
    };
    DebridgeSwapProvider.getCrossChainSwapStatus = function (sendTxHash, srcChainId, dstChainId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sendStatus, receiveStatus, signatureVerifier, _a, _b, _c, minConfirmations, count;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, transaction_service_1.TransactionService.getTransactionStatus(sendTxHash, srcChainId)];
                    case 1:
                        sendStatus = _d.sent();
                        if (!(sendStatus === transaction_status_1.TX_STATUS.SUCCESS)) return [3 /*break*/, 7];
                        _b = (_a = ethers_1.ethers.Contract).bind;
                        _c = [void 0, this.config.chains[srcChainId].signatureVerifier,
                            SignatureVerifier_json_1["default"].abi];
                        return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(srcChainId)];
                    case 2:
                        signatureVerifier = new (_b.apply(_a, _c.concat([_d.sent()])))();
                        return [4 /*yield*/, signatureVerifier.minConfirmations()];
                    case 3:
                        minConfirmations = _d.sent();
                        return [4 /*yield*/, this.getConfirmationsCount(sendTxHash)];
                    case 4:
                        count = _d.sent();
                        if (!(count >= minConfirmations)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getCrossChainSwapReceiveStatus(sendTxHash, dstChainId)];
                    case 5:
                        receiveStatus = _d.sent();
                        _d.label = 6;
                    case 6: return [2 /*return*/, { sendStatus: sendStatus, receiveStatus: receiveStatus }];
                    case 7: return [2 /*return*/, { sendStatus: sendStatus, receiveStatus: null }];
                }
            });
        });
    };
    DebridgeSwapProvider.getCrossChainSwapReceiveStatus = function (sendTxHash, dstChainId) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var submissionInfo;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getFullSubmissionInfo(sendTxHash)];
                    case 1:
                        submissionInfo = _b.sent();
                        if (((_a = submissionInfo === null || submissionInfo === void 0 ? void 0 : submissionInfo.send) === null || _a === void 0 ? void 0 : _a.isExecuted) && (submissionInfo === null || submissionInfo === void 0 ? void 0 : submissionInfo.claim)) {
                            return [2 /*return*/, transaction_service_1.TransactionService.getTransactionStatus(submissionInfo === null || submissionInfo === void 0 ? void 0 : submissionInfo.claim.transactionHash, dstChainId)];
                        }
                        return [2 /*return*/, transaction_status_1.TX_STATUS.NOT_FOUND];
                }
            });
        });
    };
    DebridgeSwapProvider.getConfirmationsCount = function (swapTxHash) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var submissionId, result, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.getSubmissionId(swapTxHash)];
                    case 1:
                        submissionId = _a.sent();
                        if (!submissionId) return [3 /*break*/, 3];
                        return [4 /*yield*/, (0, utils_1.fetchGet)(this.config.api + "SubmissionConfirmations/getForSubmission", {
                                submissionId: submissionId
                            })];
                    case 2:
                        result = _a.sent();
                        if (Array.isArray(result)) {
                            return [2 /*return*/, result.length];
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, 0];
                }
            });
        });
    };
    DebridgeSwapProvider.getSubmissionId = function (swapTxHash) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, utils_1.fetchGet)(this.config.api + "Transactions/GetFullSubmissionInfo", {
                                filter: swapTxHash,
                                filterType: 1
                            })];
                    case 1:
                        result = _b.sent();
                        return [2 /*return*/, ((_a = result === null || result === void 0 ? void 0 : result.send) === null || _a === void 0 ? void 0 : _a.submissionId) || null];
                    case 2:
                        e_3 = _b.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DebridgeSwapProvider.getFullSubmissionInfo = function (swapTxHash) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, utils_1.fetchGet)(this.config.api + "Transactions/GetFullSubmissionInfo", {
                                filter: swapTxHash,
                                filterType: 1
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result || null];
                    case 2:
                        e_4 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DebridgeSwapProvider.config = config_1.DebridgeConfig;
    return DebridgeSwapProvider;
}());
exports.DebridgeSwapProvider = DebridgeSwapProvider;
